import { FC, useCallback, useState } from "react"
import { discussionCategoryDeleteApi } from "src/domain/api/discussionCategory/discussionCategoryDeleteApi"
import { DiscussionCategory } from "src/domain/entities/discussionCategory"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	discussionCategory: DiscussionCategory
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const DiscussionCategoryDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	discussionCategory,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleDiscussionCategoryDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await discussionCategoryDeleteApi({ id: discussionCategory.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [discussionCategory, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete DiscussionCategory: ${discussionCategory.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleDiscussionCategoryDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
